/**
 * Analytics helpers for protecting product-analytics payloads.
 */

/** Keys that are considered PII and must not be sent to analytics (normalized: lower, no - or _). */
const PII_KEYS = new Set([
  "email",
  "name",
  "firstname",
  "lastname",
  "phone",
  "telephone",
  "address",
  "street",
  "city",
  "zip",
  "postalcode",
  "ssn",
  "dob",
  "dateofbirth",
  "password",
  "token",
  "secret",
]);

function normalizeKey(k: string): string {
  return k.toLowerCase().replace(/[-_]/g, "");
}

/**
 * Validate that an object does not contain PII keys. Throws if a disallowed key is present.
 */
export function validateNoPII(
  obj: Record<string, string | number | boolean>
): void {
  for (const key of Object.keys(obj)) {
    if (PII_KEYS.has(normalizeKey(key))) {
      throw new Error(`Analytics: PII key not allowed: ${key}`);
    }
  }
}
